module.exports = __webpack_public_path__ + "static/1-1b1ecc0e32978f9a075998544feee97d.jpg";